import { SubscriptionPlans } from '../../../../../shared/utils/subscription-plans';
import { getUserPlanCode } from '../../../../../shared/utils/user-details';

export const shouldShowUpgradePlanModal = () =>
  getUserPlanCode() === SubscriptionPlans.TRIAL ||
  getUserPlanCode() === SubscriptionPlans.OUTREACH_BASIC_MONTHLY ||
  getUserPlanCode() === SubscriptionPlans.OUTREACH_BASIC_YEARLY ||
  getUserPlanCode() === SubscriptionPlans.OUTREACH_BASIC_MONTHLY_8_2023 ||
  getUserPlanCode() === SubscriptionPlans.OUTREACH_BASIC_YEARLY_8_2023;
